import React, { useContext } from 'react'
import "./Review.css"
import { BsFillCreditCard2BackFill } from "react-icons/bs"
import { AiOutlineShoppingCart, AiFillShopping } from "react-icons/ai"
import { BiSolidLock } from 'react-icons/bi'
import { MdOutlineSecurity, MdCall } from 'react-icons/md'
import ReviewProd from './ReviewProd/ReviewProd'
import { Context } from '../../utils/context'
import { useNavigate } from 'react-router-dom'

function Review() {
  const {cartItems, cartSubTotal} = useContext(Context);
  const navigate = useNavigate();
  return (
    <div className='review-back-container'>
      <div className="review-main-container">
        <div className="upper-content">
          <span id='review-heading'>Cart</span>
          <div className="loading-container">
            <div className="shop-container">
              <div className='review-icon-container'>
                <AiFillShopping />
              </div>
              <span>Shop</span>
            </div>
            <div className="hr-line"></div>
            <div className="shop-container" id="active-page">
              <div className='review-icon-container'>
                <AiOutlineShoppingCart />
              </div>
              <span>Review</span>
            </div>
            <div className="hr-line" id='inactive'></div>
            <div className="shop-container">
              <div className='review-icon-container' id='inactive'>
                <BsFillCreditCard2BackFill />
              </div>
              <span>Checkout</span>
            </div>
          </div>
        </div>
        <div className="mid-content">
          {!!cartItems?.length && <>
          <div className="prod-info-container">
            <table className='desk-table'>
              <tr className='prod-info-row'>
                <th></th>
                <th>Product</th>
                <th>Category</th>
                <th>Price</th>
                <th>Quantity</th>
                <th>Subtotal</th>
              </tr>
              <ReviewProd />
            </table>
            <table className="res-table">
              <ReviewProd />
            </table>
            <div className="mid-lower-container">
              <div className="coupon-container">
                <input type="text" placeholder='Coupon Code' />
                <button className="apply-coupon-btn">APPLY COUPON</button>
              </div>
              <div className="back-to-shop">
                <button onClick={() => navigate("/shop")}>BACK TO SHOP</button>
              </div>
            </div>
          </div>
          <div className="totals-main-container">
            <div className="total-content">
              <h2>Cart Totals</h2>
              <table>
                <tbody>
                  <tr>
                    <th>SUBTOTAL</th>
                    <td>&#8377;{cartSubTotal}</td>
                  </tr>
                  <tr>
                    <th>TOTAL</th>
                    <td>&#8377;{cartSubTotal}</td>
                  </tr>
                </tbody>
              </table>
              <div className="proceed-checkout">
                <button onClick={() => navigate("/checkout")}>PROCEED TO CHECKOUT</button>
              </div>
            </div>
          </div>
          </>}
        </div>  
        <div className="lower-content">
          <div className="usp-container">
            <BiSolidLock />
            <div className="usp-heading">
              <h4>Your Information Is Safe</h4>
              <p>Donec sollicitudin molestie malesuada. Nulla porttitor accumsan tincidunt. Nulla quis lorem ut libero malesuada feugiat.</p>
            </div>
          </div>
          <div className="usp-container">
            <MdOutlineSecurity />
            <div className="usp-heading">
              <h4>Secure Checkout</h4>
              <p>Donec sollicitudin molestie malesuada. Nulla porttitor accumsan tincidunt. Nulla quis lorem ut libero malesuada feugiat.</p>
            </div>
          </div>
          <div className="usp-container">
            <MdCall />
            <div className="usp-heading">
              <h4>24/7 Customer Support</h4>
              <p>Donec sollicitudin molestie malesuada. Nulla porttitor accumsan tincidunt. Nulla quis lorem ut libero malesuada feugiat.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default Review
